import React, { useMemo, useState } from 'react';
import { useData } from '@/contexts/DataContext';
import { Separator } from '@/components/ui/separator';
import MonthlySalesMainChart from './MonthlySalesMainChart';
import TopScreensByMonth from './TopScreensByMonth';

const MonthlySalesChart = () => {
  const { sales } = useData();

  // Obtener años únicos de las ventas
  const years = useMemo(() => {
    const uniqueYears = [...new Set(sales.map(sale => new Date(sale.date).getFullYear()))];
    return uniqueYears.sort().reverse(); // Ordenar años de más reciente a más antiguo
  }, [sales]);

  // Estado para el año seleccionado (por defecto, el año más reciente)
  const [selectedYear, setSelectedYear] = useState<string>(
    years.length > 0 ? years[0].toString() : new Date().getFullYear().toString()
  );

  const handleYearChange = (value: string) => {
    setSelectedYear(value);
  };

  return (
    <div className="space-y-6">
      {/* Main sales chart */}
      <MonthlySalesMainChart
        sales={sales}
        selectedYear={selectedYear}
        onYearChange={handleYearChange}
        years={years}
      />

      {/* Separator */}
      <Separator className="w-full" />

      {/* Top screens per month section */}
      <TopScreensByMonth
        sales={sales}
        selectedYear={selectedYear}
      />
    </div>
  );
};

export default MonthlySalesChart;
